module.exports = {
  id: "vecinos360",
  domain: "vecinos360.web.app",
  siteURL: "https://dashboard.vecinos360.com",
  app: {
    apiKey: "AIzaSyCReWp3Afo6ec-3Jwl0cWurST8pNQoROa0",
    authDomain: "console-vecinos360.firebaseapp.com",
    databaseURL: "https://console-vecinos360.firebaseio.com",
    projectId: "console-vecinos360",
    storageBucket: "console-vecinos360.appspot.com",
    messagingSenderId: "84710451109",
    appId: "1:84710451109:web:f752818177662410",
  },
  tokens: [
    "vfeDcziunCoSxs3xouSjFBoSKLDDfjff99DqNLdBsQamajWPic6O93U78A4eGmdsfIQjtmrlHwMy9Dxe2A==",
  ],
  gtm_id: "GTM-TL4GZ39",
  statitics_url:
    "https://datastudio.google.com/embed/reporting/1TFZR_6K_uOoesKvQqeF9hlBywCkmzcKE/page/DVWQB",
  report_activities_url:
    "https://datastudio.google.com/embed/reporting/d26c581e-3afd-4baf-80b1-cbb57fbd36f9/page/nYLqB",
  fcm_key:
    "BBsSmnHjUKu77QIq4b2tYsvig3-OGZiagHaZ_r7xMz9MDxaovI6Ahfmbodhh7ofFUZQBXh-Io2VlFyEFlWsHrWc",
  algolia: {
    id: "LJ6G2IL9RT",
    key: "d5475b107adfc092a992e31d790f72fd",
    admin_key: "3f4e24aa1d2de7c7b161318a43b29390",
  },
  stripe: {
    pKey: "pk_test_51KEcXtL3iVi482gLTwJoF7XQqQp0t1cxdf5zruPpWM8cQe1oJ73IdoArXOeVjGQHZXIC6nzx7iKodDbWsblaIgEB00nUIa9mlT",
    plans: {
      price_1KEcshL3iVi482gLg69leHxf: "incuba",
      price_1KEd05L3iVi482gLCTlMXS5w: "emprende",
      price_1KEd1AL3iVi482gLqFzHSLZd: "escala",
    },
    priceIds: {
      incuba: "price_1KEcshL3iVi482gLg69leHxf",
      emprende: "price_1KEd05L3iVi482gLCTlMXS5w",
      escala: "price_1KEd1AL3iVi482gLqFzHSLZd",
    },
  },
  whatsappServerURL: "https://always-with-you.uc.r.appspot.com",
  contactFilters: {
    country: { id: "country", name: "País", primary: true },
  },
  contactImportData: [
    {
      header: "Nombres",
      key: "name",
      width: 30,
      type: "string",
    },
    {
      header: "Apellidos",
      key: "last_name",
      width: 30,
      type: "string",
    },
    {
      header: "Tipo de documento",
      key: "document_type",
      width: 20,
      type: "string",
    },
    {
      header: "Número de documento",
      key: "document_number",
      width: 20,
      type: "string",
    },
    {
      header: "Correo electrónico",
      key: "email",
      width: 20,
      type: "email",
    },
    {
      header: "Teléfono",
      key: "phone",
      width: 20,
      type: "string",
    },
    { header: "Comentario", key: "comment", width: 20, type: "string" },
    {
      header: "Correo del Encargado",
      key: "agent_id",
      width: 20,
      type: "agent",
    },
    { header: "Origen", key: "origin", width: 20, type: "string" },
  ],
  contactExportData: [
    { header: "Nombres", key: "name", type: "string", width: 30 },
    { header: "Apellidos", key: "last_name", type: "last_name", width: 30 },
    {
      header: "Tipo de documento",
      key: "document_type",
      width: 20,
      type: "string",
    },
    {
      header: "Número de documento",
      key: "document_number",
      width: 20,
      type: "string",
    },
    { header: "Correo electrónico", key: "email", type: "email", width: 30 },
    { header: "Teléfono", key: "phone", type: "string", width: 20 },
    {
      header: "Compañía/Comunidad",
      key: "company_name",
      width: 20,
      type: "string",
    },
    { header: "Rol", key: "rol", width: 20, type: "string" },
    {
      header: "Unidades",
      key: "number_apartments",
      width: 20,
      type: "string",
    },
    {
      header: "País",
      key: "country",
      width: 20,
      type: "string",
    },
    {
      header: "Ciudad",
      key: "city",
      width: 20,
      type: "string",
    },
    { header: "Comentario", key: "comment", width: 20, type: "string" },
    { header: "Etiquetas", key: "tags", width: 20, type: "tags" },
    { header: "Encargado", key: "agent_id", type: "agent", width: 20 },
    {
      header: " ¿Acepta términos y condiciones?",
      key: "terms",
      type: "terms",
      width: 20,
    },
    {
      header: "Última actividad",
      key: "last_comment",
      type: "string",
      width: 20,
    },
    {
      header: "Fecha de última actividad",
      key: "last_activity",
      type: "timestamp",
      width: 20,
    },
    {
      header: "Fecha de registro",
      key: "created_at",
      type: "timestamp",
      width: 20,
    },
    { header: "Origen", key: "origin", type: "string", width: 20 },
  ],
  contactFormSchema: {
    name: {
      type: "text",
      label: "Nombres",
      placeholder: "Nombres",
      flex: { xs: 12, sm: 6 },
      rules: [(v) => !!v || "Campo requerido"],
      show_on_detail: true,
      form_update: true,
      searchable: true,
    },
    last_name: {
      type: "text",
      label: "Apellidos",
      placeholder: "Apellidos",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
      searchable: true,
    },
    document_number: {
      type: "text",
      label: "DNI",
      placeholder: "DNI",
      flex: { xs: 12, sm: 6 },
      rules: [(v) => !!v || "Campo requerido"],
      show_on_detail: true,
      form_update: true,
      searchable: true,
    },
    phone: {
      type: "text",
      label: "Teléfono",
      placeholder: "Teléfono",
      flex: { xs: 12, sm: 6 },
      rules: [
        (v) =>
          // eslint-disable-next-line
          /^$|^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/.test(v) ||
          "Teléfono no válido",
      ],
      show_on_detail: true,
      form_update: true,
    },
    email: {
      type: "email",
      label: "Correo electrónico",
      placeholder: "Correo electrónico",
      flex: { xs: 12 },
      rules: [
        (v) =>
          // eslint-disable-next-line
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "Correo electrónico no válido",
      ],
      show_on_detail: true,
      no_edit: true,
      searchable: true,
    },
    country: {
      type: "autocomplete",
      label: "País",
      items: [],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6, md: 4 },
      show_on_detail: true,
      form_update: true,
    },
    city: {
      type: "combobox",
      label: "Ciudad",
      items: [],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6, md: 4 },
      show_on_detail: true,
      form_update: true,
    },
    district: {
      type: "text",
      label: "Distrito",
      items: [],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6, md: 4 },
      show_on_detail: true,
      form_update: true,
    },
    comment: {
      type: "textarea",
      label: "Comentario",
      placeholder: "Comente aquí",
      flex: { xs: 12 },
    },
    agent: {
      type: "select",
      label: "Encargado",
      items: [],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      rules: [(v) => !!v || "Campo requerido"],
    },
    newsletter: {
      type: "checkbox",
      label: "Desea recibir ofertas y promociones de Vecinos360",
      flex: { xs: 12 },
      class: "pt-5",
    },
    terms: {
      type: "checkbox",
      label: "Acepta los tÃ©rminos y condiciones de Vecinos360",
      flex: { xs: 12 },
    },
    tags: { type: "hidden", label: "Etiquetas", flex: { xs: 12 } },
  },
  tableContact: [
    {
      text: "Contacto",
      align: "left",
      sortable: false,
      value: "full_name",
    },
    {
      text: "Número de documento",
      align: "center",
      sortable: false,
      value: "document_number",
    },
    {
      text: "Email",
      align: "center",
      sortable: false,
      value: "email",
    },
    {
      text: "País",
      align: "center",
      sortable: false,
      value: "country",
    },
    {
      text: "Registrado",
      align: "center",
      value: "created_at",
      sortable: true,
    },
    {
      text: "Operación",
      align: "center",
      sortable: false,
      value: "operations",
    },
  ],
  contactActivityImportData: [
    {
      header: "Correo electrónico",
      key: "contact_email",
      width: 20,
      type: "email",
    },
    {
      header: "Tipo de actividad",
      key: "activity_type",
      width: 20,
      type: "activity",
    },
    { header: "Comentario", key: "comment", width: 40, type: "string" },
  ],
  orderImportData: [
    {
      label: "Número de boleta*",
      key: "invoice_number",
      type: "string",
      required: true,
    },
    {
      label: "DNI",
      key: "document_number",
      type: "string",
    },
    {
      header: "Nombres*",
      key: "name",
      width: 30,
      type: "string",
      required: true,
    },
    {
      header: "Apellidos",
      key: "last_name",
      width: 30,
      type: "string",
    },
    {
      header: "Correo electrónico",
      key: "email",
      width: 20,
      type: "email",
    },
    {
      header: "Teléfono",
      key: "phone",
      width: 20,
      type: "string",
    },
    {
      label: "Categoría del producto",
      key: "category",
      type: "string",
      isProductAttribute: true,
    },
    {
      label: "Dirección",
      key: "address",
      type: "string",
    },
    {
      label: "Nombre producto*",
      key: "product_name",
      width: 20,
      type: "string",
      isProductAttribute: true,
    },
    {
      label: "Cantidad producto",
      key: "product_quantity",
      width: 20,
      type: "number",
      isProductAttribute: true,
    },
    {
      label: "Precio producto (precio por unidad)",
      key: "product_price",
      width: 20,
      type: "number",
      isProductAttribute: true,
    },
    { label: "Descuento", key: "discount", type: "number" },
    {
      label: "Total venta*",
      key: "total_paid",
      type: "number",
      required: true,
    },
    {
      label: "Método de pago",
      key: "payment_method",
      type: "string",
    },
    {
      label: "Fecha de venta* (dd/mm/yyyy)",
      key: "sold_at",
      type: "date",
      required: true,
    },
  ],
  saleExportData: [
    { header: "Id", key: "id", type: "string", width: 30 },
    {
      header: "Nombres",
      key: "name",
      type: "string",
      width: 30,
      show_on_detail: true,
    },
    {
      header: "Apellidos",
      key: "last_name",
      type: "last_name",
      width: 30,
      show_on_detail: true,
    },
    {
      header: "Correo electrónico",
      key: "email",
      type: "email",
      width: 30,
      show_on_detail: true,
    },
    {
      header: "Teléfono",
      key: "phone",
      type: "string",
      width: 20,
      show_on_detail: true,
    },
    {
      header: "Tipo de documento",
      key: "document_type",
      type: "string",
      width: 30,
      show_on_detail: true,
    },
    {
      header: "Número de documento",
      key: "document_number",
      type: "string",
      width: 30,
      show_on_detail: true,
    },
    {
      header: "Producto/Cantidad/Precio",
      key: "products",
      type: "products",
      width: 30,
    },
    { header: "Descuento", key: "discount", width: 20, type: "number" },
    {
      header: "Total en productos",
      key: "total_products",
      type: "number",
      width: 20,
    },
    {
      header: "Total en delivery",
      key: "total_delivery",
      type: "number",
      width: 20,
    },
    { header: "Total a pagar", key: "total_paid", type: "number", width: 20 },
    {
      header: "Estado de pago",
      key: "payment_state",
      width: 20,
      type: "string",
    },
    {
      header: "Método de pago",
      key: "payment_method",
      type: "string",
      width: 20,
    },
    {
      header: "Estado de entrega",
      key: "delivery_state",
      width: 20,
      type: "string",
    },
    {
      header: "Método de entrega",
      key: "delivery_method",
      width: 20,
      type: "string",
    },
    {
      header: "Tienda",
      key: "store_id",
      width: 20,
      type: "store",
    },
    {
      header: "Zone",
      key: "zone_id",
      parent: "delivery",
      width: 20,
      type: "zone",
    },
    {
      header: "Dirección de entrega",
      key: "address",
      parent: "delivery",
      width: 20,
      type: "string",
    },
    {
      header: "Referencia",
      key: "reference",
      parent: "delivery",
      width: 20,
      type: "string",
    },
    { header: "Encargado", key: "agent_id", width: 20, type: "agent" },
    { header: "Origen", key: "origin", width: 20, type: "string" },
    {
      header: "Fecha de registro",
      key: "created_at",
      type: "timestamp",
      width: 20,
    },
    {
      header: "Fecha de venta",
      key: "sold_at",
      type: "timestamp",
      width: 20,
    },
    {
      header: "Agente que importó la venta",
      key: "import_by",
      width: 20,
      type: "agent",
    },
  ],
  orderFilters: {
    payment_state: {
      id: "payment_state",
      name: "Estado de pago",
      primary: true,
    },
    delivery_state: {
      id: "delivery_state",
      name: "Estado de entrega",
      primary: true,
    },
    products_ids: { id: "products_ids", name: "Producto", primary: true },
  },
  orderPaymentMethods: [
    { id: "DEB_CRED", name: "Tarjeta de crédito/débito" },
    { id: "TRANSFER", name: "Transferencia" },
    { id: "YAPE", name: "Yape" },
    { id: "UPON_DELIVERY", name: "Contra entrega" },
  ],
  orderPaymentStates: [
    {
      id: "pago-pendiente",
      name: "Pago pendiente",
      hashtag: "#o{OrdenID}eppen",
      abrev: "pen",
    },
    {
      id: "procesando-pago",
      name: "Procesando pago",
      hashtag: "#o{OrdenID}eppro",
      abrev: "pro",
    },
    {
      id: "pago-rechazado",
      name: "Pago rechazado",
      hashtag: "#o{OrdenID}eprec",
      abrev: "rec",
    },
    {
      id: "pago-completado",
      name: "Pago completado",
      hashtag: "#o{OrdenID}epcom",
      abrev: "com",
    },
  ],
  orderDeliveryMethods: [
    { id: "store", name: "Entrega en tienda" },
    { id: "address", name: "Entrega a domicilio" },
  ],
  orderDeliveryStates: [
    {
      id: "pendiente-de-entrega",
      name: "Pendiente de entrega",
      hashtag: "#o{OrdenID}eepen",
      abrev: "pen",
    },
    {
      id: "enviando-pedido",
      name: "Enviando pedido",
      hashtag: "#o{OrdenID}eeenv",
      abrev: "env",
    },
    {
      id: "pedido-entregado",
      name: "Pedido entregado",
      hashtag: "#o{OrdenID}eeent",
      abrev: "ent",
    },
    {
      id: "pedido-no-recibido",
      name: "Pedido no recibido",
      hashtag: "#o{OrdenID}eenre",
      abrev: "nre",
    },
  ],
  orderFormSchema: {
    name: {
      type: "text",
      label: "Nombres",
      placeholder: "Nombres",
      flex: { xs: 12, sm: 6 },
      rules: ["required"],
      sort: 2,
      searchable: true,
    },
    last_name: {
      type: "text",
      label: "Apellidos",
      placeholder: "Apellidos",
      flex: { xs: 12, sm: 6 },
      sort: 3,
      searchable: true,
      value: "",
    },
    document_type: {
      type: "select",
      label: "Tipo de documento",
      items: ["DNI", "Carnet de extranjería", "RUC"],
      placeholder: "Seleccione",
      rules: ["required"],
      flex: { sm: 6 },
      sort: 4,
      value: "DNI",
      searchable: true,
    },
    document_number: {
      type: "text",
      label: "Número de documento",
      placeholder: "Número de documento",
      rules: ["required"],
      flex: { sm: 6 },
      sort: 5,
      searchable: true,
    },
    email: {
      type: "email",
      label: "Correo electrónico",
      placeholder: "Correo electrónico",
      flex: { xs: 12 },
      rules: ["email"],
      sort: 6,
      searchable: true,
    },
    phone: {
      type: "text",
      label: "Teléfono",
      placeholder: "Teléfono",
      flex: { xs: 12, sm: 6 },
      sort: 7,
      searchable: true,
    },
    origin: {
      type: "autocomplete",
      label: "Origen",
      items: [
        "whatsApp",
        "facebook",
        "instagram",
        "twitter",
        "linkedIn",
        "tienda",
      ],
      placeholder: "Seleccione",
      rules: ["required"],
      flex: { xs: 12, sm: 6 },
      sort: 9,
    },
  },
  ticketFilters: {
    state: { id: "state", name: "Estado", primary: true },
    origin: { id: "origin", name: "Origen", primary: true },
    agent_id: {
      id: "agent_id",
      name: "Agente",
      primary: true,
      readonly_advisor: true,
      item_text: "full_name",
      item_value: "uid",
    },
  },
  tableTicket: [
    { text: "Contacto", align: "center", sortable: false, value: "full_name" },
    { text: "Estado", align: "center", sortable: false, value: "state" },
    {
      text: "Registrado",
      align: "center",
      sortable: false,
      value: "created_at",
    },
    { text: "Origen", align: "center", sortable: false, value: "origin" },
    { text: "Encargado", align: "center", sortable: false, value: "agent_id" },
    { text: "Operación", align: "right", sortable: false, value: "operations" },
  ],
  ticketFormSchema: {
    ticket_name: {
      type: "text",
      label: "Nombre del ticket",
      placeholder: "Nombre del ticket",
      flex: { xs: 12 },
      show_on_detail: true,
      form_update: true,
      sort: 1,
    },
    name: {
      type: "text",
      label: "Nombres",
      placeholder: "Nombres",
      flex: { xs: 12, sm: 6 },
      rules: [(v) => !!v || "Campo requerido"],
      show_on_detail: true,
      form_update: true,
      landing_rules: ["required"],
      first_word: "Nombre: ",
      show_on_landing: true,
      sort: 2,
      searchable: true,
    },
    last_name: {
      type: "text",
      label: "Apellidos",
      placeholder: "Apellidos",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
      show_on_landing: true,
      sort: 3,
      searchable: true,
    },
    phone: {
      type: "text",
      label: "Teléfono",
      placeholder: "Teléfono",
      first_word: "Teléfono móvil: ",
      flex: { xs: 12, sm: 6 },
      rules: [
        (v) =>
          // eslint-disable-next-line
          /^$|^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/.test(v) ||
          "Teléfono no válido",
      ],
      show_on_detail: true,
      show_on_landing: true,
      sort: 4,
      searchable: true,
    },
    phone_secondary: {
      type: "text",
      label: "Teléfono convencional",
      placeholder: "Teléfono convencional",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      first_word: "Teléfono convencional: ",
      show_on_landing: true,
      sort: 5,
    },
    document_type: {
      type: "select",
      label: "Tipo de documento",
      landing_rules: ["required"],
      items: ["DNI", "Carnet de extranjería", "RUC"],
      show_on_detail: true,
      show_on_landing: true,
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      sort: 6,
      searchable: true,
    },
    document_number: {
      type: "text",
      label: "Número de documento",
      landing_rules: ["required"],
      placeholder: "Número de documento",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      show_on_landing: true,
      sort: 7,
      searchable: true,
    },
    email: {
      type: "email",
      label: "Correo electrónico",
      placeholder: "Correo electrónico",
      flex: { xs: 12 },
      rules: [
        (v) =>
          // eslint-disable-next-line
          !v ||
          (!!v &&
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              v
            )) ||
          "Correo electrónico no válido",
      ],
      show_on_detail: true,
      no_edit: true,
      landing_rules: ["required", "email"],
      first_word: "Correo: ",
      show_on_landing: true,
      sort: 8,
      searchable: true,
    },
    country: {
      type: "autocomplete",
      label: "País",
      items: [],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6, md: 4 },
      show_on_detail: true,
      form_update: true,
      sort: 9,
    },
    city: {
      type: "combobox",
      label: "Ciudad",
      items: [],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
      sort: 10,
    },
    district: {
      type: "text",
      label: "Distrito",
      items: [],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6, md: 4 },
      show_on_detail: true,
      form_update: true,
      sort: 11,
    },
    quotation_code: {
      type: "text",
      label: "Código de cotización",
      placeholder: "Código de cotización",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      sort: 12,
      searchable: true,
    },
    quotation_date_expired: {
      type: "date",
      data_type: "date",
      label: "Fecha de expiración de cotización",
      placeholder: "Fecha de expiración de cotización",
      ext: "text",
      menu: { closeOnContentClick: true, nudgeRight: 200 },
      locale: "es",
      appendIcon: "far fa-calendar-alt",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
      sort: 13,
    },
    company_name: {
      type: "text",
      label: "Compañía/Comunidad",
      placeholder: "Compañía/Comunidad",
      flex: { xs: 12, sm: 6, md: 4 },
      show_on_detail: true,
      form_update: true,
      sort: 12,
    },
    rol: {
      type: "select",
      label: "Rol",
      items: [
        "Administrador Independiente",
        "Vecino",
        "Empresa Administradora",
      ],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6, md: 4 },
      show_on_detail: true,
      form_update: true,
      sort: 13,
    },
    number_departaments: {
      type: "text",
      label: "Cantidad de departamentos",
      placeholder: "Cantidad de departamentos",
      flex: { xs: 12, sm: 6, md: 4 },
      show_on_detail: true,
      form_update: true,
      sort: 14,
    },
    problem: {
      type: "text",
      label: "Problema",
      placeholder: "Problema",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
      sort: 15,
    },
    subject: {
      type: "text",
      label: "Asunto",
      placeholder: "Asunto",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
      sort: 16,
    },
    admins_selected_names: {
      type: "text",
      label: "Administradores a cotizar",
      placeholder: "Administradores a cotizar",
      flex: { xs: 12 },
      show_on_detail: true,
      sort: 17,
    },
    comment: {
      type: "text",
      label: "Comentario",
      placeholder: "Comente aquí",
      show_on_landing: true,
      landing_rules: ["required"],
      flex: { xs: 12 },
      sort: 18,
    },
    project: {
      type: "select",
      label: "Proyecto",
      items: ["default", "vecinos360-admins", "recaudos"],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
      sort: 19,
    },
    medium_contact: {
      type: "select",
      label: "Medio de contacto",
      items: [
        "Whatsapp",
        "Facebook",
        "Instagram",
        "Twitter",
        "Llamada",
        "Correo",
        "Consulta",
        "Web",
        "Evento",
        "Sala de ventas",
      ],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      rules: [(v) => !!v || "Campo requerido"],
      show_on_detail: true,
      form_update: true,
      sort: 20,
    },
    agent: {
      type: "select",
      label: "Encargado",
      items: [],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      sort: 21,
    },
    origin: {
      type: "autocomplete",
      label: "Origen",
      items: [],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      sort: 22,
    },
    tags: {
      type: "hidden",
      data_type: "tags",
      label: "Etiquetas",
      flex: { xs: 12 },
      sort: 23,
    },
    terms: {
      type: "hidden",
      data_type: "boolean",
      label: "TÃ©rminos y Condiciones",
      flex: { xs: 12 },
      sort: 24,
    },
  },
  ticketImportData: [
    {
      header: "Nombre del Ticket",
      key: "ticket_name",
      type: "string",
      width: 30,
    },
    {
      header: "Nombres*",
      key: "name",
      width: 30,
      outlineLevel: 1,
      type: "string",
      validate: true,
      required: true,
    },
    {
      header: "Apellidos",
      key: "last_name",
      width: 30,
      outlineLevel: 1,
      type: "string",
    },
    {
      header: "Tipo de documento",
      key: "document_type",
      width: 20,
      type: "string",
    },
    {
      header: "Número de documento",
      key: "document_number",
      width: 20,
      type: "string",
    },
    {
      header: "Correo electrónico",
      key: "email",
      width: 20,
      type: "email",
    },
    {
      header: "Teléfono",
      key: "phone",
      width: 20,
      type: "string",
    },
    {
      header: "Asunto",
      key: "subject",
      width: 20,
      type: "string",
    },
    {
      header: "Problema",
      key: "problem",
      width: 20,
      type: "string",
    },
    {
      header: "Compañía/Comunidad",
      key: "company_name",
      width: 20,
      type: "string",
    },
    { header: "Rol", key: "rol", width: 20, outlineLevel: 1, type: "string" },
    {
      header: "Unidades",
      key: "number_apartments",
      width: 20,
      type: "string",
    },
    { header: "Comentario", key: "comment", width: 20, type: "string" },
    {
      header: "Correo del Encargado",
      key: "agent_id",
      width: 20,
      type: "agent",
      validate: true,
    },
    {
      header: "Origen",
      key: "origin",
      width: 20,
      type: "string",
      validate: true,
      required: true,
    },
  ],
  ticketExportData: [
    { header: "Ticket", key: "ticket_name", type: "string", width: 30 },
    { header: "Nombres", key: "name", type: "string", width: 30 },
    { header: "Apellidos", key: "last_name", type: "last_name", width: 30 },
    {
      header: "Tipo de documento",
      key: "document_type",
      width: 20,
      type: "string",
    },
    {
      header: "Número de documento",
      key: "document_number",
      width: 20,
      type: "string",
    },
    { header: "Correo electrónico", key: "email", type: "email", width: 30 },
    { header: "Teléfono", key: "phone", type: "string", width: 20 },
    {
      header: "País",
      key: "country",
      width: 20,
      type: "string",
    },
    {
      header: "Ciudad",
      key: "city",
      width: 20,
      type: "string",
    },
    {
      header: "Distrito",
      key: "district",
      width: 20,
      type: "string",
    },
    {
      header: "Compañía/Comunidad",
      key: "company_name",
      width: 20,
      type: "string",
    },
    { header: "Rol", key: "rol", width: 20, type: "string" },
    {
      header: "Unidades",
      key: "number_apartments",
      width: 20,
      type: "string",
    },
    { header: "Asunto", key: "subject", width: 20, type: "string" },
    {
      header: "Administradores a cotizar",
      key: "admins_selected_names",
      width: 20,
      type: "string",
    },
    { header: "Comentario", key: "comment", width: 20, type: "string" },
    { header: "Estado", key: "state", type: "state", width: 20 },
    { header: "Etiquetas", key: "tags", width: 20, type: "tags" },
    { header: "Encargado", key: "agent_id", type: "agent", width: 20 },
    {
      header: "Fecha de registro",
      key: "created_at",
      type: "timestamp",
      width: 20,
    },
    {
      header: "Ãšltima actividad",
      key: "last_comment",
      type: "string",
      width: 20,
    },
    {
      header: "Fecha de Ãºltima actividad",
      key: "last_activity",
      type: "timestamp",
      width: 20,
    },
    { header: "Origen", key: "origin", type: "string", width: 20 },
  ],
  ticketActivityImportData: [
    {
      header: "ID del Ticket",
      key: "ticket_id",
      width: 20,
      outlineLevel: 1,
      type: "string",
    },
    {
      header: "Tipo de actividad",
      key: "activity_type",
      width: 20,
      type: "activity",
    },
    { header: "Comentario", key: "comment", width: 40, type: "string" },
  ],
  agentTable: [
    {
      text: "Nombres y Apellidos",
      align: "left",
      value: "full_name",
    },
    {
      text: "Correo electrónico",
      align: "left",
      value: "email",
    },
    {
      text: "Rol",
      align: "center",
      sortable: false,
      value: "role",
    },
    {
      text: "Tienda",
      align: "center",
      value: "projects",
    },
    {
      text: "Estado",
      align: "center",
      sortable: false,
      value: "active",
    },
    {
      text: "Operación",
      align: "center",
      sortable: false,
      value: "operations",
    },
  ],
  agentFormSchema: {
    name: {
      type: "text",
      label: "Nombres",
      placeholder: "Nombres",
      flex: { xs: 12, sm: 6 },
      rules: [(v) => !!v || "Campo requerido"],
      show_on_detail: true,
      form_update: true,
    },
    last_name: {
      type: "text",
      label: "Apellidos",
      placeholder: "Apellidos",
      flex: { xs: 12, sm: 6 },
      rules: [(v) => !!v || "Campo requerido"],
      show_on_detail: true,
      form_update: true,
    },
    email: {
      type: "email",
      label: "Correo electrónico",
      placeholder: "Correo electrónico",
      flex: { xs: 12 },
      rules: [
        (v) => !!v || "Campo requerido",
        (v) =>
          // eslint-disable-next-line
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "Correo electrónico no válido",
      ],
      show_on_detail: true,
    },
  },
  campaignTable: [
    {
      text: "Canal",
      align: "center",
      value: "channel",
    },
    {
      text: "Campaña",
      align: "center",
      value: "campaign_name",
    },
    {
      text: "Ciudad",
      align: "center",
      value: "city",
    },
    {
      text: "Distrito",
      align: "center",
      value: "district",
    },
    {
      text: "Edad mínima",
      align: "center",
      value: "min_age",
    },
    {
      text: "Edad máxima",
      align: "center",
      value: "max_age",
    },
    {
      text: "Registros",
      align: "center",
      value: "count_records",
    },
    {
      text: "Presupuesto",
      align: "center",
      value: "amount",
    },
    {
      text: "CAR",
      align: "center",
      value: "car",
    },
    {
      text: "Fecha de inicio",
      align: "center",
      value: "campaign_date",
    },
    {
      text: "Fecha de fin",
      align: "center",
      value: "campaign_end_date",
    },
  ],
  campaignBudgetExportData: [
    {
      header: "Canal",
      key: "channel",
      type: "string",
      width: 30,
    },
    {
      header: "Campaña",
      key: "campaign_name",
      type: "string",
      width: 30,
    },
    {
      header: "Ciudad",
      key: "city",
      type: "string",
      width: 20,
    },
    {
      header: "Distrito",
      key: "district",
      type: "string",
      width: 20,
    },
    {
      header: "Edad mínima",
      key: "min_age",
      width: 15,
      type: "string",
    },
    {
      header: "Edad máxima",
      key: "max_age",
      width: 15,
      type: "string",
    },
    {
      header: "Registros",
      key: "count_records",
      type: "number",
      width: 10,
    },
    {
      header: "Presupuesto",
      key: "amount",
      type: "number",
      width: 15,
    },
    {
      header: "CAR",
      key: "car",
      type: "number",
      width: 10,
    },
    {
      header: "Fecha de inicio",
      key: "campaign_date",
      width: 30,
      type: "timestamp",
    },
    {
      header: "Fecha de fin",
      key: "campaign_end_date",
      type: "timestamp",
      width: 30,
    },
  ],
  theme: {
    themes: {
      light: {
        primary: "#ff7101", // "#FF5100",
        secondary: "#ffa600",
        accent: "#009ffd",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FB8C00",
      },
      dark: {
        primary: "#ff7101", // "#FF5100",
        secondary: "#ffa600",
        accent: "#009ffd",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FB8C00",
      },
    },
  },
};
